import { z } from 'zod';
export const UserNotificationSettingSchema = z.object({
    id: z.string(),
    name: z.string()
});
//# sourceMappingURL=userNotificationSettingSchema.js.map